import { render, staticRenderFns } from "./IcdMenuBtns.vue?vue&type=template&id=4dcf20d1&scoped=true&"
import script from "./IcdMenuBtns.vue?vue&type=script&lang=js&"
export * from "./IcdMenuBtns.vue?vue&type=script&lang=js&"
import style0 from "./IcdMenuBtns.vue?vue&type=style&index=0&id=4dcf20d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcf20d1",
  null
  
)

export default component.exports